import React, { useRef, useState, useEffect } from 'react';

const isPDFEnabled = navigator?.pdfViewerEnabled;
const IMAGE_EXTENSIONS = ['.png', '.jpeg', '.jpg'];

const FileViewer = ({ url, fileExt }) => {
  const { iframeRef, isLoading, loaded } = useGoogleViewer();
  const googleViewerError = !isLoading && !loaded;

  // We just use an img tag if the file is an image.
  if (IMAGE_EXTENSIONS.includes(fileExt)) {
    return (
      <div className="page-content img-viewer">
        <img src={url} />
      </div>
    );
  }

  // If google viewer fails to load,
  // We check the browser if it is able to render pdfs natively.
  if (googleViewerError && fileExt === '.pdf' && isPDFEnabled) {
    return (
      <div className="page-content pdf-viewer">
        <object
          type="application/pdf"
          data={url}
          width="500px"
          height="800px"
        />
      </div>
    );
  }

  // The google viewer failed and either browser does not support pdfs,
  // or the file is not a pdf.
  if (googleViewerError && !isPDFEnabled) {
    return (
      <div className="page-content unsupported-viewer">
        <p>
          This file cannot be viewed in your current browser. Please download
          the file to view it or try using a different browser.
        </p>
      </div>
    );
  }

  // Attempt to use Google viewer to view files. Attached ref will update state if the iframe
  // does not fire onload event after a certain time.
  return (
    <div className="page-content google-viewer">
      <iframe
        ref={iframeRef}
        src={
          `https://docs.google.com/viewer?embedded=true&url=${encodeURIComponent(url)}`
        }
        title="Note file viewer"
        width="100%"
      />
    </div>
  );
};

const useGoogleViewer = () => {
  const iframeRef = useRef(null);
  const [isLoading, setIsLoading] = useState(true);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (iframeRef.current) {
      iframeRef.current.onload = () => {
        setLoaded(true);
        setIsLoading(false);
      };

      // Wait 10 seconds for the iframe to load.
      // If it does not load, we stop trying to load and defer to backup.
      setTimeout(() => {
        if (!loaded) {
          setIsLoading(false);
        }
      }, 10000);
    }
  }, []);

  return { iframeRef, isLoading, loaded };
};

export default FileViewer;
